import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react'

const customConfig = defineConfig({
  globalCss: {
    html: {
      colorPalette: 'blue',
      color: 'text.main',
    },
    form: {
      display: 'block',
      width: 'full',
    },
  },
  theme: {
    tokens: {
      fonts: {
        heading: { value: "'Inter', 'Hiragino Sans', 'Meiryo'" },
        body: { value: "'Inter', 'Hiragino Sans', 'Meiryo'" },
      },
      colors: {
        black: {
          value: '#000000',
        },
        white: {
          value: '#FFFFFF',
        },
        whiteAlpha: {
          50: {
            value: '#ffffff0a',
          },
          100: {
            value: '#ffffff0f',
          },
          200: {
            value: '#ffffff14',
          },
          300: {
            value: '#ffffff29',
          },
          400: {
            value: '#ffffff3d',
          },
          500: {
            value: '#ffffff5c',
          },
          600: {
            value: '#ffffff7a',
          },
          700: {
            value: '#ffffffa3',
          },
          800: {
            value: '#ffffffcc',
          },
          900: {
            value: '#ffffffeb',
          },
        },
        blackAlpha: {
          50: {
            value: '#0000000a',
          },
          100: {
            value: '#0000000f',
          },
          200: {
            value: '#00000014',
          },
          300: {
            value: '#00000029',
          },
          400: {
            value: '#0000003d',
          },
          500: {
            value: '#0000005c',
          },
          600: {
            value: '#0000007a',
          },
          700: {
            value: '#000000a3',
          },
          800: {
            value: '#000000cc',
          },
          900: {
            value: '#000000eb',
          },
        },
        gray: {
          50: {
            value: '#f7fafc',
          },
          100: {
            value: '#edf2f7',
          },
          200: {
            value: '#e2e8f0',
          },
          300: {
            value: '#cbd5e0',
          },
          400: {
            value: '#a0aec0',
          },
          500: {
            value: '#718096',
          },
          600: {
            value: '#4a5568',
          },
          700: {
            value: '#2d3748',
          },
          800: {
            value: '#1a202c',
          },
          900: {
            value: '#171923',
          },
        },
        red: {
          50: {
            value: '#fdf3f4',
          },
          100: {
            value: '#fde3e4',
          },
          200: {
            value: '#fbccd0',
          },
          300: {
            value: '#fda4ac',
          },
          400: {
            value: '#f5747f',
          },
          500: {
            value: '#e54855',
          },
          600: {
            value: '#d52d3b',
          },
          700: {
            value: '#a82d37',
          },
          800: {
            value: '#94202a',
          },
          900: {
            value: '#7e1e26',
          },
        },
        orange: {
          50: {
            value: '#fffaf0',
          },
          100: {
            value: '#feebcb',
          },
          200: {
            value: '#fbd38d',
          },
          300: {
            value: '#f6ad55',
          },
          400: {
            value: '#ed8936',
          },
          500: {
            value: '#dd6b20',
          },
          600: {
            value: '#c05621',
          },
          700: {
            value: '#9c4221',
          },
          800: {
            value: '#7b341e',
          },
          900: {
            value: '#652b19',
          },
        },
        yellow: {
          50: {
            value: '#ffffea',
          },
          100: {
            value: '#fffbc5',
          },
          200: {
            value: '#fef9a0',
          },
          300: {
            value: '#ffee46',
          },
          400: {
            value: '#ffe01b',
          },
          500: {
            value: '#ffc40f',
          },
          600: {
            value: '#e29400',
          },
          700: {
            value: '#bb6902',
          },
          800: {
            value: '#7c420b',
          },
          900: {
            value: '#482200',
          },
        },
        green: {
          50: {
            value: '#effaf2',
          },
          100: {
            value: '#e5f5e9',
          },
          200: {
            value: '#c8e9d2',
          },
          300: {
            value: '#85d0a1',
          },
          400: {
            value: '#55b27c',
          },
          500: {
            value: '#2f9a5f',
          },
          600: {
            value: '#228654',
          },
          700: {
            value: '#186442',
          },
          800: {
            value: '#186442',
          },
          900: {
            value: '#13412e',
          },
        },
        teal: {
          50: {
            value: '#f2fbf9',
          },
          100: {
            value: '#dff6f1',
          },
          200: {
            value: '#bcebe3',
          },
          300: {
            value: '#71d7ca',
          },
          400: {
            value: '#52c3b7',
          },
          500: {
            value: '#2aa298',
          },
          600: {
            value: '#1f827c',
          },
          700: {
            value: '#1d6864',
          },
          800: {
            value: '#1b5452',
          },
          900: {
            value: '#1b4644',
          },
        },
        blue: {
          50: {
            value: '#f0f4fe',
          },
          100: {
            value: '#dde7fc',
          },
          200: {
            value: '#c2d4fa',
          },
          300: {
            value: '#99bbf7',
          },
          400: {
            value: '#6997f1',
          },
          500: {
            value: '#3e6cea',
          },
          600: {
            value: '#3858d8',
          },
          700: {
            value: '#314ec4',
          },
          800: {
            value: '#2942a4',
          },
          900: {
            value: '#273981',
          },
        },
        cyan: {
          50: {
            value: '#edfdfd',
          },
          100: {
            value: '#c4f1f9',
          },
          200: {
            value: '#9decf9',
          },
          300: {
            value: '#76e4f7',
          },
          400: {
            value: '#0bc5ea',
          },
          500: {
            value: '#00b5d8',
          },
          600: {
            value: '#00a3c4',
          },
          700: {
            value: '#0987a0',
          },
          800: {
            value: '#086f83',
          },
          900: {
            value: '#065666',
          },
        },
        purple: {
          50: {
            value: '#fbf5fe',
          },
          100: {
            value: '#f5e8fe',
          },
          200: {
            value: '#ecd5fd',
          },
          300: {
            value: '#ddb4fb',
          },
          400: {
            value: '#c888f4',
          },
          500: {
            value: '#b359f2',
          },
          600: {
            value: '#9f3deb',
          },
          700: {
            value: '#8831bf',
          },
          800: {
            value: '#7329a0',
          },
          900: {
            value: '#5f2281',
          },
        },
        pink: {
          50: {
            value: '#fcf3fa',
          },
          100: {
            value: '#fae9f5',
          },
          200: {
            value: '#f7d3ee',
          },
          300: {
            value: '#f3aee0',
          },
          400: {
            value: '#e87ec8',
          },
          500: {
            value: '#db4dac',
          },
          600: {
            value: '#c93992',
          },
          700: {
            value: '#ad2977',
          },
          800: {
            value: '#8b2861',
          },
          900: {
            value: '#782354',
          },
        },
        skyblue: {
          50: {
            value: '#f1f9fe',
          },
          100: {
            value: '#e2f2fc',
          },
          200: {
            value: '#bee4f9',
          },
          300: {
            value: '#79c9f2',
          },
          400: {
            value: '#43b7ed',
          },
          500: {
            value: '#1a9edd',
          },
          600: {
            value: '#0c7fbd',
          },
          700: {
            value: '#0b6599',
          },
          800: {
            value: '#0e557e',
          },
          900: {
            value: '#124768',
          },
        },
      },
      shadows: {
        xs: {
          value: '0 0 0 1px rgba(0, 0, 0, 0.05)',
        },
        sm: {
          value: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        },
        base: {
          value:
            '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
        },
        md: {
          value:
            '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        },
        lg: {
          value:
            '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        },
        xl: {
          value:
            '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        },
        '2xl': {
          value: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        },
        outline: {
          value: '0 0 0 3px rgba(66, 153, 225, 0.6)',
        },
        inner: {
          value: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
        },
        'dark-lg': {
          value:
            '0px 0px 0px 1px rgba(0, 0, 0, 0.10), 0px 5px 10px 0px rgba(0, 0, 0, 0.20), 0px 15px 40px 0px rgba(0, 0, 0, 0.40)',
        },
      },
      radii: {
        none: { value: '0rem' },
        sm: { value: '0.125rem' },
        base: { value: '0.25rem' },
        md: { value: '0.375rem' },
        lg: { value: '0.5rem' },
        xl: { value: '0.75rem' },
        '2xl': { value: '1rem' },
        '3xl': { value: '1.5rem' },
        full: { value: '9999px' },
      },
    },
    semanticTokens: {
      colors: {
        border: {
          gray: { value: '{colors.gray.300}' },
          error: { value: '{colors.red.500}' },
        },
        text: {
          main: { value: '{colors.gray.800}' },
          sub: { value: '{colors.gray.600}' },
          primary: { value: '{colors.blue.500}' },
          danger: { value: '{colors.red.500}' },
          error: { value: '{colors.red.500}' },
          success: { value: '{colors.green.500}' },
          warning: { value: '{colors.orange.500}' },
        },
        status: {
          mono: { value: '{colors.gray.600}' },
          primary: { value: '{colors.blue.500}' },
          error: { value: '{colors.red.500}' },
          success: { value: '{colors.green.500}' },
          warning: { value: '{colors.orange.500}' },
        },
        background: {
          blue: { value: '{colors.blue.50}' },
          gray: { value: '{colors.gray.50}' },
        },
      },
      spacing: {
        SS: {
          value: { base: '{spacing.1}', desktop: '{spacing.2}' },
        },
        S: {
          value: { base: '{spacing.2}', desktop: '{spacing.3}' },
        },
        M: {
          value: { base: '{spacing.3}', desktop: '{spacing.4}' },
        },
        L: {
          value: { base: '{spacing.4}', desktop: '{spacing.6}' },
        },
        LL: {
          value: { base: '{spacing.6}', desktop: '{spacing.8}' },
        },
      },
      opacity: {
        disabled: {
          value: '0.4',
        },
      },
    },
    breakpoints: {
      desktop: '834px',
    },
  },
})

export const system = createSystem(defaultConfig, customConfig)
